export default {
  v3SubmitErrBtnViewOrder: 'Lihat Pesanan',
  v3SubmitErrBtnBackHome: 'Beranda',
  v3SubmitErrBtnRetry: 'Ulangi',
  v3SubmitErrBtnRelogin: 'Login Ulang',
  v3SubmitErrBtnSwitchPay: 'Ganti Metode Bayar',
  v3SubmitErrBtnReorder: 'Pesan Ulang',
  v3SubmitErrBtnSwitchServer: 'Ganti Server',
  v3SubmitErrBtnViewOrderStatus: 'Status Pesanan',
  v3SubmitErrBtnBackStore: 'Kembali ke Toko',
  v3SubmitErrBtnGoUpdate: 'Perbarui',
  v3SubmitErrBtnResubscribe: 'Berlangganan Ulang',
  v3SubmitErrTipUpdateApp: 'Perbarui melalui App Store',
  v3SubmitErrTipRelogin: 'Silakan login ulang',

  v3SubmitErrMsg120009: 'Pesanan diproses – cek ransel dalam game.',
  v3SubmitErrMsg120003: 'Info produk salah – pilih ulang.',
  v3SubmitErrMsg120016: 'Terlalu sering mengirim – tunggu beberapa detik dan coba lagi.',
  v3SubmitErrMsg120025: 'Parameter permintaan tidak normal – login ulang dan coba lagi.',
  v3SubmitErrMsg121012: 'Saluran pembayaran sementara tidak tersedia – coba metode lain.',
  v3SubmitErrMsg120012: 'Jaringan tidak stabil – periksa koneksi dan coba lagi.',
  v3SubmitErrMsg120002: 'Karakter game tidak ditemukan – buat karakter dulu.',
  v3SubmitErrMsg121019: 'Info pesanan salah – silakan pesan ulang.',
  v3SubmitErrMsg120024: 'Hadiah pra-registrasi sudah diambil – tidak perlu ulangi.',
  v3SubmitErrMsg120000: 'Login kedaluwarsa – login ulang.',
  v3SubmitErrMsg120014: 'Nomor pesanan tidak valid – pesan ulang.',
  v3SubmitErrMsg121001: 'Isi ulang game gagal – coba lagi nanti atau hubungi CS.',
  v3SubmitErrMsg120015: 'Jumlah pembayaran tidak normal – pilih ulang produk.',
  v3SubmitErrMsg120001: 'Server tidak cocok – pindah ke server yang benar.',
  v3SubmitErrMsg120020: 'Saluran pembayaran mengembalikan error – coba metode lain.',
  v3SubmitErrMsg120010: 'Fungsi isi ulang game sementara ditutup – coba lagi nanti.',
  v3SubmitErrMsg120006: 'Verifikasi jumlah gagal – pilih ulang.',
  v3SubmitErrMsg121010: 'Permintaan isi ulang di sandbox tidak valid – gunakan versi resmi.',
  v3SubmitErrMsg120017: 'Nomor pesanan duplikat – periksa apakah sudah dibayar.',
  v3SubmitErrMsg120022: 'Verifikasi callback pembayaran gagal – coba lagi nanti.',
  v3SubmitErrMsg121000: 'Sistem sibuk – coba lagi nanti.',
  v3SubmitErrMsg120011: 'ID produk salah – pilih ulang.',
  v3SubmitErrMsg121015: 'Verifikasi jumlah pembayaran gagal – pesan ulang.',
  v3SubmitErrMsg120004: 'Saluran pembayaran saat ini belum dibuka – pilih metode lain.',
  v3SubmitErrMsg120005: 'Saluran pembayaran dalam pemeliharaan – gunakan metode lain.',
  v3SubmitErrMsg120007: 'ID platform salah – login ulang.',
  v3SubmitErrMsg120008: 'Parameter permintaan tidak cukup – kirim ulang.',
  v3SubmitErrMsg120013: 'Nomor pesanan pengembang salah – pesan ulang.',
  v3SubmitErrMsg120018: 'Pembayaran diblokir oleh kontrol risiko – hubungi CS untuk verifikasi.',
  v3SubmitErrMsg120019: 'Verifikasi nama paket gagal – gunakan versi resmi.',
  v3SubmitErrMsg120021: 'Verifikasi ID produk gagal – pilih ulang.',
  v3SubmitErrMsg120023: 'Hadiah pra-registrasi gagal dikirim – cek nanti.',
  v3SubmitErrMsg120026: 'Akun tidak ditemukan – periksa status akun.',
  v3SubmitErrMsg120030: 'Stok total tidak mencukupi – pilih produk lain.',
  v3SubmitErrMsg120031: 'Anda telah melebihi batas pembelian produk ini – sesuaikan.',
  v3SubmitErrMsg120032: 'Versi game terlalu lama – unduh versi terbaru.',
  v3SubmitErrMsg120080: 'Pembayaran agen dibatasi oleh kontrol risiko – gunakan metode pembayaran sendiri.',
  v3SubmitErrMsg120081: 'Pembayaran agen ditunda oleh kontrol risiko – cek hasil nanti.',
  v3SubmitErrMsg121002: 'Cache pesanan tidak valid – pesan ulang.',
  v3SubmitErrMsg121003: 'Konfigurasi isi ulang tidak ditemukan – hubungi CS.',
  v3SubmitErrMsg121004: 'Parameter tambahan tidak cukup – kirim ulang.',
  v3SubmitErrMsg121005: 'Penulisan cache gagal – coba lagi nanti.',
  v3SubmitErrMsg121006: 'Pembacaan cache gagal – coba lagi nanti.',
  v3SubmitErrMsg121007: 'Error konfigurasi tipe isi ulang – hubungi CS.',
  v3SubmitErrMsg121011: 'Field baru terdeteksi dari Apple – perbarui aplikasi.',
  v3SubmitErrMsg121013: 'Pesanan perpanjangan tidak ditemukan – berlangganan ulang.',
  v3SubmitErrMsg121014: 'Dekripsi parameter isi ulang gagal – kirim ulang.',
  v3SubmitErrMsg121017: 'Pesanan ini telah dikembalikan dananya – hubungi CS untuk konfirmasi.',
  v3SubmitErrMsg121018: 'Langganan kedaluwarsa – berlangganan ulang.',
  v3SubmitErrMsg121020: 'Pesanan dibatalkan – pesan ulang.',
  v3SubmitErrMsg121021: 'Error Google API – coba lagi nanti.',
  v3SubmitErrMsg121022: 'Gagal mendapatkan token akses – login ulang.',
  v3SubmitErrMsg121023: 'Status pesanan tidak normal – cek status masuk.',
  v3SubmitErrMsg121024: 'Konfirmasi pesanan gagal – coba lagi nanti.'
};
